/** @file Why Apply failed, in words: STALE_REV gets its own sentence (analyse again), the rest errorText. */
import { toPose2DError } from '@pose2d/format/toPose2DError';
import type { Translate } from '@pose2d/i18n/types';
import { errorText } from '../../shell/i18n/errorText';

/** The project moved on since the analysis: the plan was made for another rev, so it is never re-sent blindly. */
export function applyFailureText(t: Translate, thrown: unknown): string {
  const error = toPose2DError(thrown);
  return error?.code === 'STALE_REV' ? t('autorig.stale', error.params) : errorText(t, thrown);
}
